import { head, pick, get } from 'lodash-es'
import { isProductAvailable } from '@/js/plugins/store/modules/products/helper.js'
import ProductBatteryUpgradesExistMixin from '@/js/mixins/product-battery-upgrades-exist-mixin.js'

export default {
  mixins: [ProductBatteryUpgradesExistMixin],
  data() {
    return {
      batteryUpgradeChoice: undefined,
    }
  },
  computed: {
    batteryUpgradeCurrency() {
      return this.batteryUpgrades ? this.batteryUpgrades?.currency : ''
    },
    batteryUpgradeClient() {
      return this.batteryUpgrades ? this.batteryUpgrades?.client : ''
    },
    batteryUpgradeOptions() {
      return (this.batteryUpgrades ? this.batteryUpgrades?.options || [] : []).map(option => {
        const availability = this.getAvailability(option.sku)
        const isAvailable = isProductAvailable(head(availability))
        const groupPrices = {
          [this.batteryUpgradeClient]: {
            value: option.upgrade_price,
            currency: this.batteryUpgradeCurrency,
            client: this.batteryUpgradeClient,
          },
        }
        return {
          ...option,
          disabled: !isAvailable,
          availabilityData: {
            articleType: 'part',
            availability,
            groupPrices,
          },
        }
      })
    },
    batteryUpgradeDefaultOption() {
      const defaultOption = this.batteryUpgradeOptions.find(
        option => option.is_default && !option.disabled,
      )
      return defaultOption || this.batteryUpgradeOptions.find(option => !option.disabled)
    },
    batteryUpgradeSkus() {
      return (this.batteryUpgrades?.options || []).map(option => option.sku)
    },
    batteryUpgradeAvailabilities() {
      return pick(this.availabilities, this.batteryUpgradeSkus) || {}
    },
    startValueBatteryUpgradeChoice() {
      return get(
        this.basketValues,
        ['batteryUpgradeChoice', 1],
        this.batteryUpgradeDefaultOption ? this.batteryUpgradeDefaultOption?.value : undefined,
      )
    },
  },
  watch: {
    startValueBatteryUpgradeChoice: {
      handler() {
        if (this.batteryUpgradeChoice !== this.startValueBatteryUpgradeChoice) {
          this.batteryUpgradeChoice = this.startValueBatteryUpgradeChoice
        }
      },
      immediate: true,
    },
  },
}
